import { ContactListFilterItem } from '../types/ContactListFilterItem';
import { UpdateListRequest } from '../types/Lists';

/**
 * buildUpdateListRequest
 *
 * @description
 * Builds a new UpdateListRequest object, adding default values for optional properties
 * if none passed in.
 *
 * @param args
 */
export const buildUpdateListRequest = (args: {
    listId: number;
    name: string;
    filters?: ContactListFilterItem[];
    viewId: number;
    items?: number[];
    isFavorite?: boolean;
    isArchived?: boolean;
}): UpdateListRequest => ({
    listId: args.listId,
    name: args.name,
    filters: args.filters || [],
    viewId: args.viewId,
    items: args.items || [],
    isFavorite: args.isFavorite || false,
    isArchived: args.isArchived || false,
});
